const matchTenantTool = (pathname: string): boolean => !!pathname.match(/^\/tenant-tool/);

export default matchTenantTool;
